import { TargetVehicleInformation } from './../../../../../../interfaces/credit-application-config.interface';
import { IPreQualEvent } from './../../../../../../interfaces/analytics.interface';
import { IConfirmationClickEvent } from './../../../../../../interfaces/analytics.interface';
import { AnalyticsEventService } from './../../../../../../services/analytics-event.service';
import { PreQualFormEventConstant } from './../../../../../../enum/analytics.enum';
import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { getBackButton } from '../../../../../../utils/utils.functions';
import {
  PrequalResponse,
  PrequalOutcome,
} from '../../../../../../interfaces/prequal-response.interface';
import { IConfig } from '../../../../../../interfaces/config.interface';
import {
  StoreInfo,
  StoreHour,
  DetailedStoreHour,
} from '../../../../../../interfaces/credit-application-config.interface';
import { DayOfTheWeek } from '../../../../../../enum/day-of-the-week.enum';
import { PreQualConfirmationClickEvents, PreQualConfirmationComponentLoaded } from '../../../../../../actions/analytics.action';
import { ComponentName } from '../../../../../../enum/component-name.enum';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DomSanitizer } from '@angular/platform-browser';
import { AnalyticsBuynowEventService } from './../../../../../../services/analytics-buynow-event.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dt-prequal-result',
  templateUrl: './prequal-result.component.html',
  styleUrls: ['./prequal-result.component.scss'],
  standalone: false
})
export class PrequalResultComponent implements OnInit {
  @Input() outcome: PrequalOutcome;
  SCData: any;
  storeInfo: StoreInfo;
  storeHours: StoreHour[] = [];
  PrequalResponse: PrequalResponse | any;
  latitude;
  longitude;
  vehicleInfo: TargetVehicleInformation;
  showBuyNowVehicle = false;
  isBuyNow = false;
  ctaDeactivate = false;
  IsStandAlonePreQual = false;
  hasbackButton = false;
  private analyticsEventService: AnalyticsEventService;
  isVDPentry = false;
  apiDomain: any;
  @Output() back = new EventEmitter<boolean>();
  constructor(
    @Inject('config') public config: IConfig,
    private analyticsEventSvc: AnalyticsEventService,
    private analyticsBuynowEventSvc: AnalyticsBuynowEventService,
    private ngxService: NgxUiLoaderService,
    public sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    if (this.config && this.config.Sitecore && this.config.Sitecore.CreditApplicationConfig) {
      this.SCData = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation;
      this.isBuyNow = this.config.Sitecore.isBuyNow ? this.config.Sitecore.isBuyNow : false;
      this.analyticsEventService = this.isBuyNow ? this.analyticsBuynowEventSvc : this.analyticsEventSvc;
      this.IsStandAlonePreQual = this.config.Sitecore.IsStandAlonePreQual ? this.config.Sitecore.IsStandAlonePreQual : false;
      this.storeInfo = this.config.Sitecore.StoreInfo;
      this.isVDPentry = !!this.config.Sitecore.leftRailVehicleData;
      if (this.storeInfo) {
        this.latitude = this.storeInfo.Latitude;
        this.longitude = this.storeInfo.Longitude;

        if (this.storeInfo.DetailedHours) {
          this.mapStoreHours();
        } else {
          this.storeInfo.DetailedHours = [];
        }
      }
      if(this.config.Sitecore.apiDomain) {
        this.apiDomain = this.config.Sitecore.apiDomain;
      }
    }
    this.mapResponse();
    this.setupTealiumInitDatEvent();

    const ele = document.getElementById('BuyNowRecalculateModal');
    if (ele) {
      ele.classList.remove('d-none');
    }
  }

  setupTealiumInitDatEvent() {
    const info: any = { prequalAmt: this.PrequalResponse ? this.PrequalResponse.preQualAmt : 0 };
    const data: IPreQualEvent = {
      componentName: ComponentName.PreQualConfirmationComponent,
      isVinAvailable: null,
       data: info,
       isBuyNowPrequalSelected: this.SCData? this.SCData.IsPrequalSelectedByDefault: '',
      type: PreQualFormEventConstant.PreQualConfirmationLoaded
    };
    if(this.analyticsEventService) {
    this.analyticsEventService.reportAnalyticsEvent(new PreQualConfirmationComponentLoaded(data));
    }
  }

  mapStoreHours() {
    this.storeInfo.DetailedHours.forEach((hour) => {
      this.mapTodaysHours(hour);
      this.mapHours(hour);
    });
  }

  mapHours(hour: DetailedStoreHour) {
    this.storeHours.push({
      day: this.dayOfWeekAsString(hour.Day),
      hours: this.getHours(hour.StartTime, hour.EndTime),
      isToday: this.isToday(hour.Day),
    });
  }

  mapTodaysHours(hour: DetailedStoreHour) {
    if (this.isToday(hour.Day)) {
      this.storeHours.unshift({
        day: this.SCData.StoreHoursLabel,
        hours:
          this.SCData.TodayLabel +
          ' ' +
          this.getHours(hour.StartTime, hour.EndTime),
        isToday: this.isToday(hour.Day),
      });
    }
  }

  mapResponse() {
    const response: PrequalResponse = this.getResponse();
    const firstName =
      this.outcome && this.outcome.firstName !== ''
        ? ', ' + this.outcome.firstName
        : '';
    response.data.preQualHeader = response.data.preQualHeader.replace(
      ', {FIRSTNAME}',
      firstName
    );
    this.SCData.FailureHeader = this.SCData.FailureHeader.replace(
      ', {FIRSTNAME}',
      firstName
    );

    this.PrequalResponse = response.data;
    this.vehicleInfo = this.getVehicleInformation();
    if (this.config && this.config.Sitecore) {
      this.showBuyNowVehicle = this.config.Sitecore.isBuyNow && (this.vehicleInfo != null && this.vehicleInfo.VehicleImage != null);
    }
  }

  getDomainImage(src) {
    let apiDomain = this.config.Sitecore.apiDomain ? this.config.Sitecore.apiDomain.replace('/pre-qualification','') : '';
    return `${apiDomain}${src}`
  }

  addFailureCss() {
    const paddingElems = document.querySelectorAll('.standAloneBoostrapWrapper .padding-container');
     const isMobile = window.innerWidth < 768;
  if (paddingElems.length > 0) {
    paddingElems.forEach((el: any) => {
       if (isMobile) {
      el.style.setProperty('padding', '30px 30px 10%', 'important');
      el.style.setProperty('height', '100vh', 'important');
    } else {
      el.style.setProperty('height', 'calc(100% - 50px)', 'important');
    }
    });
  }
  const containers = document.querySelectorAll('.standaloneprequal-row .preQual-container');
  if (containers.length > 0 && isMobile) {
    containers.forEach((el: HTMLElement) => {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('justify-content', 'center', 'important');
      el.style.setProperty('align-items', 'center', 'important');
    });
  }
}
isFailure() {
  this.addFailureCss();
  if (this.apiDomain && (this.outcome?.prequalAmt < this.PrequalResponse.preQualMinAmt)) {
      return true;
  }
}
  getPreQualHeader() {
    if (!this.PrequalResponse.preQualHeader) {
      /* istanbul ignore next */
      return '';
    }
    this.addFailureCss();
    if (this.outcome?.prequalAmt < this.PrequalResponse.preQualMinAmt) {
     
      return this.SCData.FailureHeader;
    }

    if (this.IsStandAlonePreQual && this.outcome && this.outcome.status) {
      const msg =  this.PrequalResponse.preQualHeader;
      const index = msg.indexOf('!');
      if (index !== -1) {
        return this.apiDomain ? 'You’re prequalified for a monthly payment up to ':  msg.substring(0, index + 1) + '<br/>' + msg.substring(index + 1, msg.length);
      }
    }
    return this.apiDomain ? 'You’re prequalified for a monthly payment up to ': this.PrequalResponse.preQualHeader;
  }

  getResponse(): PrequalResponse {
    return {
      data: {
        preQualIcon:
          this.outcome && this.outcome.status
            ? this.SCData? this.SCData.SuccessIcon : ''
            : this.SCData? this.SCData.FailureIcon: '',
        preQualHeader:
          this.outcome && this.outcome.status
            ? this.SCData? this.SCData.SuccessHeader: ''
            : this.SCData? this.SCData.FailureHeader : '',
        preQualAmt: this.outcome && this.outcome.prequalAmt,
        preQualAmtSuffix: this.SCData.SuccessHeaderQualAmtSuffix,
        preQualMinAmt: this.SCData.SuccessHeaderQualMinAmt,
        preQualFailureDisclaimerVDPentry: this.SCData.FailureDisclaimerVDPEntry,
        preQualFailureDisclaimer: this.SCData.FailureDisclaimer,
        preQualDisclaimer: this.SCData?.SuccessDisclaimer,
        success: this.outcome && this.outcome.status
      },
    };
  }
  dayOfWeekAsString(dayIndex) {
    return [
      DayOfTheWeek.Monday.toString(),
      DayOfTheWeek.Tuesday.toString(),
      DayOfTheWeek.Wednesday.toString(),
      DayOfTheWeek.Thursday.toString(),
      DayOfTheWeek.Friday.toString(),
      DayOfTheWeek.Saturday.toString(),
      DayOfTheWeek.Sunday.toString(),
    ][dayIndex];
  }

  getHours(sTime: string, eTime: string) {
    if (sTime === '') {
      return this.SCData.ClosedLabel;
    }
    return sTime + ' - ' + eTime;
  }

  isToday(day: number) {
    return day + 1 === new Date().getDay();
  }

  private getVehicleInformation() {
    if (!this.config || !this.config.Sitecore || !this.config.Sitecore.PreQualLeadInfo) {
      return null;
    }
    const leadInfo = this.config.Sitecore.PreQualLeadInfo;
    return {
      MakeModelName: `${leadInfo.year > 0 ? leadInfo.year : ''} ${leadInfo.make
        } ${leadInfo.model} `,
      StyleName: leadInfo.styleName,
      VehicleImage: leadInfo.vehicleImage,
    };
  }

  public getCityState() {
    if (!(this.storeInfo && this.storeInfo.Address)) {
      return '';
    }
    return (
      this.storeInfo.Address.City +
      ', ' +
      this.storeInfo.Address.StateCode +
      ' ' +
      this.storeInfo.Address.PostalCode
    );
  }

  reportTealium(target: string, phone: string) {
    const data: IConfirmationClickEvent = {
      isPhoneClicked: target === 'phone',
      isVinAvailable: false,
      componentName: ComponentName.PreQualConfirmationComponent,
      phone,
    };
    if(this.analyticsEventService){
    this.analyticsEventService.reportAnalyticsEvent(
      new PreQualConfirmationClickEvents(data)
    );
    }
  }
  // method that returns navigator object
  public getNavigatorReference(): any {
    return navigator;
  }

  openMapsStore() {
    let url = '';
    const nav = this.getNavigatorReference();
    if (
      nav.platform.indexOf('iPhone') !== -1 ||
      nav.platform.indexOf('iPod') !== -1 ||
      nav.platform.indexOf('iPad') !== -1
    ) {

      url =
        'maps://maps.google.com/maps?daddr=' +
        this.latitude +
        ',' +
        this.longitude +
        '&amp;ll=';
    } else {
      url =
        'https://maps.google.com/maps?daddr=' +
        this.latitude +
        ',' +
        this.longitude +
        '&amp;ll=';
    }
    window.open(url);
  }

  getClass(firstItem: any, hours: string) {
    if(this.SCData && this.SCData.ClosedLabel) {
    if (hours === this.SCData.ClosedLabel) {
      return 'store-info-sh-closed';
    }
  }
    if (firstItem) {
      return 'p-0 today';
    }
    return 'pr-0 store-info-sh-hour';
  }
/* istanbul ignore next */
  goNext() {
    this.ctaDeactivate = true;
    try {
      getBackButton();
      this.ngxService.startLoader('creditApplicationPrecualConfirmation');
      if (this.isBuyNow && (window as any).buynow) {
        (window as any).buynow.navigation.moveNext();
      }
    } catch (e) {
      console.log(e);
      this.ctaDeactivate = false;
      this.ngxService.stopAllLoader('creditApplicationPrecualConfirmation');
    }
  }
  /* istanbul ignore next */
  goBack() {
    this.back.emit(true);
    try {
      if (this.isBuyNow) {
        (window as any).ctaBuyNowReload.reloadView();
      }
    } catch (e) {
      console.log(e);
    }
  }

  isEmpty(str: string) {
    return (!str || str.length === 0);
  }

}
